enum FixedRoute {
    Home = "",
    Policy = "policy",
    Privacy = "policy/privacy",
    TermsAndConditions = "policy/terms",
    CookiePolicy = "policy/cookies",
    SignUp = "signUp",
    SignUpSSO = "signUpSSO",
    SignUpOptions = "signUpOptions",
    SignIn = "signIn",
    SignInSSO = "signInSSO",
    New = "new",
    Share = "share",
    Preview = "preview",
    Edit = "edit",
    ForgotPassword = "forgotPassword",
    ResetPassword = "resetPassword",
    Settings = "settings",
    Compatibility = "compatibility",
    CompatibilityCelebrity = "compatibility/celebrity",
    CompatibilityUser = "compatibility/user",
    Unsubscribe = "unsubscribe",
}

export {FixedRoute}